import * as React from 'react';
import { ConstructorArguments } from '../typings';

export default async (): Promise<React.ComponentClass<ConstructorArguments>> => {
  const module = await import('./WelcomeMessagePopupComponent');

  return module.default;
};
